export const CENT_MULTIPLIER = 100
